export const language: any = {
  LabelFavorites: "お気に入り",
  LabelYouDontHaveRecipeAddYourFavoriteRecipe:
    "まだお気に入りの料理がありません。<br/>お気に入りの料理を追加しましょう！",
  LabelDoYouWantUnSave: "このレシピを保存解除しますか？",
  save: "保存",
  unsave: "保存解除",
  OkFavorite: "はい",
  CloseFavorite: "いいえ",
};
